import {Injectable} from "@angular/core";
import {ISession, ISessionWorklistData} from "../../interfaces/isession";
import {BehaviorSubject} from "rxjs";
import {LogCat, LogManager} from "../../../../../common/log";
import {
	IMDTMeetingsWorklistInput,
	IMDTMeetingsWorklistRequest
} from "../../components/mdt.meetings.worklist/interfaces/mdt.meetings.worklist.interface";
import {MDTMeetingsService} from "../../../../../app.services/mdt.meetings/services/mdt.meetings.service";

@Injectable({ providedIn: 'root' })
  export class SessionWorklistDataService {
	public worklistDataSubject = new BehaviorSubject<ISessionWorklistData>(null);

	constructor(private mdtMeetingsService: MDTMeetingsService) {
	}

	public setSessionWorklistData(s:ISession, wlKeys) {
		let sessionWorklistData = {
			siteWorklistKey: wlKeys[0],
			// On next operation in presentation and justification sessions we add the worklist request to the session params
			// When open session via the worklist, the conference data is in the worklist session (parent of the current session)
			conferenceKey: s.data.params['worklistRequest'] ?
				(<IMDTMeetingsWorklistRequest>(s.data.params['worklistRequest'])).conferenceKey :
				(<IMDTMeetingsWorklistInput>(s.parent?.data?.params))?.conferenceKey,
			conferenceDate: s.data.params['worklistRequest'] ?
				(<IMDTMeetingsWorklistRequest>(s.data.params['worklistRequest'])).conferenceDate :
				this.mdtMeetingsService.getWorklistMeetingDate(<IMDTMeetingsWorklistInput>(s.parent?.data?.params))
		};
		LogManager.debug(LogCat.Session.WorklistData, "setSessionWorklistData ", sessionWorklistData);
		this.worklistDataSubject.next(sessionWorklistData);
	}
}
